<p-dialog
  [header]="title"
  [(visible)]="visible"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: width }"
  [dismissableMask]="dismissableMask"
  [closable]="closable"
  (onHide)="onHide()"
  class="custom-dialog"
>
  <!-- Confirmation Dialog -->
  <div *ngIf="modalType === 'confirm'" class="space-y-4">
    <div class="flex items-center gap-3">
      <i class="pi pi-exclamation-triangle text-2xl text-orange-500"></i>
      <p class="text-gray-700">{{ message }}</p>
    </div>
  </div>

  <!-- Comment/Approve/Reject Form -->
  <div
    *ngIf="
      modalType === 'comment' ||
      modalType === 'approve' ||
      modalType === 'reject'
    "
    class="space-y-4"
  >
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2"
        >Comment</label
      >
      <textarea
        pInputTextarea
        [(ngModel)]="commentText"
        placeholder="Enter your comment here..."
        rows="4"
        class="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      ></textarea>
    </div>
  </div>

  <!-- Upload Form -->
  <div *ngIf="modalType === 'upload'" class="space-y-4">
    <div
      class="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center"
    >
      <div class="flex flex-col items-center">
        <i class="pi pi-upload text-4xl text-gray-400 mb-2"></i>
        <p class="text-gray-600 mb-4">
          Drag and drop files here or click to browse
        </p>
        <p class="text-sm text-gray-500 mb-4">
          Supported formats: PDF, DOC, DOCX (Max 10MB)
        </p>
        <input
          type="file"
          multiple
          accept=".pdf,.doc,.docx,.txt"
          (change)="onFileSelect($event)"
          class="hidden"
          #fileInput
        />
        <button
          pButton
          type="button"
          label="Choose Files"
          class="p-button-outlined"
          (click)="fileInput.click()"
        ></button>
      </div>
    </div>

    <!-- Selected Files List -->
    <div *ngIf="uploadedFiles.length > 0" class="space-y-2">
      <h4 class="font-medium text-gray-700">Selected Files:</h4>
      <div
        *ngFor="let file of uploadedFiles; let i = index"
        class="flex items-center justify-between p-2 bg-gray-50 rounded"
      >
        <span class="text-sm text-gray-700">{{ file.name }}</span>
        <div class="flex items-center gap-2">
          <span class="text-xs text-gray-500"
            >{{ (file.size / 1024 / 1024).toFixed(2) }} MB</span
          >
          <button
            pButton
            type="button"
            icon="pi pi-times"
            class="p-button-text p-button-sm"
            (click)="removeFile(i)"
          ></button>
        </div>
      </div>
    </div>
  </div>

  <!-- Custom Content -->
  <div *ngIf="modalType === 'custom'">
    <ng-content></ng-content>
  </div>

  <!-- Footer with action buttons -->
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      @if (modalType === 'confirm') {
      <button
        pButton
        type="button"
        [label]="cancelButtonText"
        class="p-button-text"
        [disabled]="confirmButtonDisabled"
        (click)="onClose()"
      ></button>
      <button
        pButton
        type="button"
        [label]="confirmButtonText"
        class="p-button-danger"
        [disabled]="confirmButtonDisabled"
        (click)="onSubmit()"
      ></button>
      } @else if (modalType === 'comment' || modalType === 'approve' ||
      modalType === 'reject') {
      <button
        pButton
        type="button"
        [label]="submitButtonLabel"
        class="button-submit"
        [disabled]="!commentText.trim() || submitInProgress"
        [loading]="submitInProgress"
        (click)="onSubmit()"
      ></button>
      } @else {
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-text"
        (click)="onClose()"
      ></button>
      <button
        pButton
        type="button"
        label="Submit"
        class="p-button-primary"
        [disabled]="modalType === 'upload' && uploadedFiles.length === 0"
        (click)="onSubmit()"
      ></button>
      }
    </div>
  </ng-template>
</p-dialog>
